import Header from "../../headerone/Main";
import Breadcrumb from "../../Breadcrumb/Main";
import { Link } from "react-router-dom";
import PublicationScript from './PublicationScript'
// Sample publication data grouped by year


const uniqueStyles = {
  container: {
    margin: "20px",
  },
  row: {
    margin: "10px 0",
  },
  label: {
    fontWeight: "bold",
    color: "#333", // Change text color
  },
  select: {
    padding: "8px", // Increase padding for better aesthetics
    border: "1px solid #ccc",
    borderRadius: "5px", // Increase border radius
    backgroundColor: "#f9f9f9", // Add a background color
    color: "#333", // Change text color
  },
  heading: {
    fontSize: "28px", // Increase font size
    margin: "10px 0",
    color: "#333", // Change text color
    display: "inline-block",
  },
  ul: {
    listStyle: "null",
    padding: "0",
  },
  li: {
    margin: "10px 0", // Increase margin for better spacing
    color: "#666", // Change text color
  },
};

function Publication() {
  return (
    <>
      <Header />
      <Breadcrumb title="Home" subtitle="Publication" />

      <section
        className="event event03 pt-120 pb-90 p-relative fix"
        style={{ background: "#f7f9ff" }}
      >
        <div className="container">
          <div className="row">
            <div
              className="col-lg-12 col-md-12  wow fadeInUp animated"
              data-animation="fadeInUp"
              data-delay=".4s"
            >
              <div
                className="section-title center-align mb-50 wow fadeInDown animated"
                data-animation="fadeInDown"
                data-delay=".4s"
              >
                <h5>
                  <i className="fal fa-graduation-cap" /> Publications
                </h5>
                <h2>Publications</h2>
              </div>
              <div className="publications scrollbar4">
                {PublicationScript.map((currPubl, index) => (
                  <a
                    href={currPubl.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="c-right ml-40"
                  >
                    <div className="event-item mb-10 hover-zoomin" key={index}>
                      <div className="event-content">
                        <div className="icon mt-1">
                          <i className="fal fa-book"></i>
                        </div>
                        <div className="text">
                          <h6>
                            <Link to="/"> {currPubl.title}</Link>
                          </h6>
                          <span className="author">
                            {/* <i className="fal fa-user-circle me-1"></i> */}
                            {currPubl.author}
                          </span>

                          {currPubl.dated && (
                            <span className="dated">
                              <i className="fal fa-calendar-alt ms-3 me-1"></i>
                              {currPubl.dated}
                            </span>
                          )}
                          {currPubl.journal && (
                            <span className="journal fst-italic">
                              <i className="fa fa-thumbtack fst-italic ms-3 me-1"></i>{" "}
                              {currPubl.journal}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>
                  </a>
                ))}
              </div>
              {/*<div className="slider-btn mt-3 float-end">*/}
              {/*  <Link to="/about" className="btn ss-btn smoth-scroll">*/}
              {/*    View All*/}
              {/*    <i className="fal fa-long-arrow-right" />*/}
              {/*  </Link>*/}
              {/*</div>*/}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Publication;
